import React from "react";
import {ButtonProps} from "../types";
import {
  IconWrapper,
  AnimationWrapper,
  TextWrapper,
  SvgIcon,
} from "./shared-animation-styles";

const SuccessAnimation = ({
  successMessage,
}: Pick<ButtonProps, "successMessage">): JSX.Element => {
  return (
    <AnimationWrapper
      aria-busy="false"
      aria-label={successMessage}
      aria-live="polite"
      role="alert"
    >
      <IconWrapper>
        <SvgIcon
          height="20"
          viewBox="0 0 30 30"
          width="20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M15 0c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C0 6.716 6.716 0 15 0zm0 2C7.82 2 2 7.82 2 15s5.82 13 13 13 13-5.82 13-13S22.18 2 15 2zm5.463 7.65l2.492 2.145-9.787 9.689-5.52-4.788 2.529-2.64 2.991 2.64 7.295-7.046z" />
        </SvgIcon>
      </IconWrapper>
      <TextWrapper>{successMessage}</TextWrapper>
    </AnimationWrapper>
  );
};

export default SuccessAnimation;
